import { useContext, useEffect, useState } from "react";
import { TranslationContext } from "../../contexts/TranslationContext";
import { NavPage } from "../../services/NavService";
import { CabinetClient, IUserSolution } from "../../services/WebApiClient";
import { LoginContext } from "../EditorCommon/LoginContext";
import { LoadSpinner } from "../LoadSpinner";
import { TopNav } from "../TopNav/TopNav";
import { ReceiptModal } from "./ReceiptModal";
import { UserSolutionTable } from "./UserSolutionTable";


export function CabinetList(props: {

}) {

    const loginContext = useContext(LoginContext);
    const tc = useContext(TranslationContext);
    const [orderRevision, setOrderRevision] = useState(0);
    const [showReceiptFor, setShowReceiptFor] = useState<IUserSolution>();

    const [userSolutions, setUserSolutions] = useState<IUserSolution[] | undefined>(undefined);

    useEffect(() => {
        const cabinetClient = new CabinetClient(undefined, loginContext.loginService.http);
        cabinetClient.getCabinetList()
            .then(cl => {
                setUserSolutions(cl.userSolutions);
            });
    },
        [loginContext.loginService.http, orderRevision]);

    function updateOrderRevision() {
        setOrderRevision(orderRevision + 1);
    }

    return (
        <>
            <TopNav header={tc.translator(NavPage.User.CabinetList)} />

            {(userSolutions === undefined)
                ? <LoadSpinner />
                : <UserSolutionTable
                    userSolutions={userSolutions}
                    orderChanged={updateOrderRevision}
                    onOrderComplete={setShowReceiptFor}
                />
            }

            {showReceiptFor?.orderNumber &&
                <ReceiptModal
                    onClose={() => setShowReceiptFor(undefined)}
                    userSolution={showReceiptFor}
                />
            }

        </>
    );
}
